/**
 * <pg-share>: share an article (sections/pg-main-article.liquid).
 * Shows the native share sheet button where the browser has one (phones), always offers
 * "copy link" (check + toast on success), and leaves the network links as plain links.
 */
import { PgElement, define, toast } from '@pg/core';

class PgShare extends PgElement {
  mount() {
    const { native, nativeItem, copy } = this.refs;
    const data = { url: this.dataset.url, title: this.dataset.title };

    if (navigator.share && nativeItem) {
      nativeItem.hidden = false;
      native.addEventListener(
        'click',
        () => navigator.share(data).catch(() => {}), // a dismissed sheet is not an error
        { signal: this.signal },
      );
    }

    copy?.addEventListener(
      'click',
      async () => {
        try {
          await navigator.clipboard.writeText(data.url || location.href);
          copy.classList.add('is-done');
          toast(this.dataset.copied || '');
          setTimeout(() => copy.classList.remove('is-done'), 2000);
        } catch {
          window.prompt('', data.url || location.href);
        }
      },
      { signal: this.signal },
    );
  }
}

define('pg-share', PgShare);
